import { ReactComponent as Logo } from '../../assets/imgs/logo.svg'

export default Logo
